module.exports = __webpack_public_path__ + "img/loading.0348ebd6.jpg";